import IconWorkflowCard from "./icon-workflow-card";

export { IconWorkflowCard };
